import React, { lazy } from 'react'
import {
  OnlyMarketplace,
  OnlyStorefront,
  OnlyStorefrontOrStorefrontPro,
} from '@retailer-platform/dashboard/gin-and-tonic'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { loyaltyAccessControl } from '../access-control/loyaltyAccess.configuration'

const LoyaltyProgramsListPage = lazy(() =>
  import(
    /* webpackChunkName: "LoyaltyProgramsListPage" */
    '../pages/loyalty-programs-list'
  ).then(module => ({ default: module.LoyaltyProgramsListPage }))
)
const CreateLoyaltyProgramPage = lazy(() =>
  import(
    /* webpackChunkName: "CreateLoyaltyProgramPage" */
    '../pages/create-loyalty-program'
  ).then(module => ({ default: module.CreateLoyaltyProgramPage }))
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
export const loyaltyPartnerScopedRouter = (
  <DomainRoute route="loyalty-partner-scoped" accessControl={loyaltyAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="loyalty-list"
        component={LoyaltyProgramsListPage as React.ComponentType<any>}
        accessControl={loyaltyAccessControl}
      />
      <DomainRoute
        exact
        route="loyalty-list-marketplace"
        component={
          ((props: any) => (
            <LoyaltyProgramsListPage {...props} extraStoreConfigFilter={OnlyMarketplace} />
          )) as React.ComponentType<any>
        }
        accessControl={loyaltyAccessControl}
      />
      <DomainRoute
        exact
        route="loyalty-list-storefront"
        component={
          ((props: any) => (
            <LoyaltyProgramsListPage {...props} extraStoreConfigFilter={OnlyStorefront} />
          )) as React.ComponentType<any>
        }
        accessControl={loyaltyAccessControl}
      />
      <DomainRoute
        exact
        route="loyalty-list-storefront-pro"
        component={
          ((props: any) => (
            <LoyaltyProgramsListPage
              {...props}
              extraStoreConfigFilter={OnlyStorefrontOrStorefrontPro}
            />
          )) as React.ComponentType<any>
        }
        accessControl={loyaltyAccessControl}
      />
      <DomainRoute
        exact
        route="loyalty-create"
        component={CreateLoyaltyProgramPage as React.ComponentType<any>}
        accessControl={loyaltyAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
